var React = require('react');

function Wedding (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m16 41.54325c8.6168157 0 15.602125-6.9853093 15.602125-15.602125s-6.9853093-15.602125-15.602125-15.602125-15.602125 6.9853093-15.602125 15.602125 6.9853093 15.602125 15.602125 15.602125zm0-3.9676875c6.4255224 0 11.6344375-5.2089151 11.6344375-11.6344375s-5.2089151-11.6344375-11.6344375-11.6344375-11.6344375 5.2089151-11.6344375 11.6344375 5.2089151 11.6344375 11.6344375 11.6344375zm5.611375-37.1188125h-10.9116875l-2.604875 4.3439375h16.1214375zm-3.81675 9.8004375 6.421625-5.4565h-16.1214375l6.31575 5.3668125m-3.710875-9.71075 5.273625 4.3439375 5.6380625-4.3439375","fill":"none","stroke":"#006aff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","transform":"translate(1 1)"}));
}

Wedding.defaultProps = {"height":"44","viewBox":"0 0 34 44","width":"34"};

module.exports = Wedding;

Wedding.default = Wedding;
